export class UploadPreviewFile {
    constructor(public id: number, public file: File, public name: string, public data: string) {
    }
}
